import React, { memo } from "react";
import { Box, Button, Grid, IconButton, MenuItem, Typography } from "@mui/material";
import IpdTextField from "../../../../utils/IpdTextField";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import FormField from "../FormField";
import ConfigurableField from "../ConfigurableField";
import { FAMILY_RELATIONS } from "../../constants/registrationConstants";
import { CONFIGURED_SECTION_IDS } from "../../utils/sectionConfiguration";
import { useSectionConfig } from "../../context/SectionConfigContext";

const S = CONFIGURED_SECTION_IDS;

function Emergencies({ patient, updateListItem, addListItem, removeListItem, errors = {} }) {
  const { canAddListEntry, canRemoveListEntry, config, getListFieldGridSize } = useSectionConfig();
  const md = config ? getListFieldGridSize(S.emergency) : 3;
  const defaultItem = { name: "", relation: "", phone: "", address: "" };

  return (
    <Box>
      {errors.emergencyContacts__min && (
        <Typography variant="caption" color="error" sx={{ display: "block", mb: 1 }}>
          {errors.emergencyContacts__min}
        </Typography>
      )}
      {patient.emergencyContacts.map((e, i) => (
        <Grid container spacing={2} key={i} alignItems="flex-start" sx={{ border: 1, borderColor: "divider", borderRadius: 1, p: 2, mb: 2 }}>
          <ConfigurableField sectionId={S.emergency} fieldName="name" xs={12} md={md}>
            {({ required }) => (
              <FormField label="Name" required={required} error={errors[`emergencyContacts.${i}.name`]}>
                <IpdTextField fullWidth size="small" value={e.name} onChange={(ev) => updateListItem("emergencyContacts", i, "name", ev.target.value)} error={Boolean(errors[`emergencyContacts.${i}.name`])} />
              </FormField>
            )}
          </ConfigurableField>
          <ConfigurableField sectionId={S.emergency} fieldName="relation" xs={12} md={md}>
            {({ required }) => (
              <FormField label="Relation" required={required} error={errors[`emergencyContacts.${i}.relation`]}>
                <IpdTextField select fullWidth size="small" value={e.relation} onChange={(ev) => updateListItem("emergencyContacts", i, "relation", ev.target.value)} error={Boolean(errors[`emergencyContacts.${i}.relation`])}>
                  <MenuItem value="">Select</MenuItem>
                  {FAMILY_RELATIONS.map((r) => <MenuItem key={r} value={r}>{r}</MenuItem>)}
                </IpdTextField>
              </FormField>
            )}
          </ConfigurableField>
          <ConfigurableField sectionId={S.emergency} fieldName="phone" xs={12} md={md}>
            {({ required }) => (
              <FormField label="Phone" required={required} error={errors[`emergencyContacts.${i}.phone`]}>
                <IpdTextField fullWidth size="small" value={e.phone} onChange={(ev) => updateListItem("emergencyContacts", i, "phone", ev.target.value)} error={Boolean(errors[`emergencyContacts.${i}.phone`])} />
              </FormField>
            )}
          </ConfigurableField>
          <ConfigurableField sectionId={S.emergency} fieldName="address" xs={12} md={md}>
            {({ required }) => (
              <FormField label="Address" required={required} error={errors[`emergencyContacts.${i}.address`]}>
                <IpdTextField fullWidth size="small" value={e.address} onChange={(ev) => updateListItem("emergencyContacts", i, "address", ev.target.value)} error={Boolean(errors[`emergencyContacts.${i}.address`])} />
              </FormField>
            )}
          </ConfigurableField>
          {canRemoveListEntry(S.emergency, patient.emergencyContacts.length) && (
            <Grid item xs={12} md={1}>
              <IconButton aria-label="Remove emergency contact" onClick={() => removeListItem("emergencyContacts", i)}><DeleteIcon /></IconButton>
            </Grid>
          )}
        </Grid>
      ))}
      {canAddListEntry(S.emergency, patient.emergencyContacts.length) && (
        <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={() => addListItem("emergencyContacts", { ...defaultItem })}>
          Add Emergency Contact
        </Button>
      )}
    </Box>
  );
}

export default memo(Emergencies);
